const Loader = () => {
  return (
    <>
      <div className="fixed inset-0 bg-gray-300 bg-opacity-50 flex justify-center items-center z-20">
        <i className="fa-regular fa-compass animate-spin text-8xl text-indigo-500"></i>
      </div>
    </>
  );
};

export default Loader;
